const ESC = '\x1B';
const GS = '\x1D';
const FS = '\x1C';
const NUL = '\x00';

// Comandos ESC/POS comunes
const CMD = {
  INIT: ESC + '@',
  BOLD_ON: ESC + 'E' + '\x01',
  BOLD_OFF: ESC + 'E' + '\x00',
  ALIGN_LEFT: ESC + 'a' + '\x00',
  ALIGN_CENTER: ESC + 'a' + '\x01',
  ALIGN_RIGHT: ESC + 'a' + '\x02',
  CUT_PAPER_FULL: GS + 'V' + '\x00',
  LF: '\n',
  SET_CODE_PAGE_PC850: ESC + 't' + '\x02',
  TEXT_SIZE_NORMAL: GS + '!' + '\x00',
  TEXT_SIZE_DOUBLE_WIDTH: GS + '!' + '\x01', // ANCHO
  TEXT_SIZE_DOUBLE_HEIGHT: GS + '!' + '\x10', // ALTO
  TEXT_SIZE_DOUBLE_WIDTH_HEIGHT: GS + '!' + '\x11', // ANCHO Y ALTO
  // Nuevos comandos para texto más pequeño
  TEXT_SIZE_SMALL: GS + '!' + '\x00', // Tamaño normal (base)
  TEXT_SIZE_CONDENSED: ESC + '\x0F', // Texto condensado (más estrecho)
  TEXT_SIZE_NORMAL_WIDTH: ESC + '\x14', // Volver a ancho normal
  // Alternativa con comando de escala
  TEXT_SCALE_SMALL: GS + '!' + '\x00', // 1x1 (normal)
  TEXT_SCALE_SMALLER: ESC + '\x0F', // CAMBIADO: usar condensado en lugar de 'M'
  TEXT_SCALE_NORMAL_FONT: ESC + '\x14', // CAMBIADO: usar normal width en lugar de 'P'
  PRINT_NV_LOGO: (keyCode, mode = 0) => FS + 'p' + String.fromCharCode(keyCode) + String.fromCharCode(mode),
  BARCODE_HEIGHT_DEFAULT: GS + 'h' + '\x50', // Altura del código de barras (80 puntos por defecto)
  BARCODE_WIDTH_MODULE_DEFAULT: GS + 'w' + '\x02', // Ancho del módulo más estrecho (0.25mm por defecto con 2 puntos)
  HRI_POSITION_BELOW: GS + 'H' + '\x02', // Imprimir caracteres HRI debajo del código de barras
  HRI_POSITION_NONE: GS + 'H' + '\x00', // No imprimir caracteres HRI
  FACTORY_RESET_SPECULATIVE: ESC + 'c' + '1' + '\x00',
};

// --- Funciones de Utilidad ---
function padRight(str, length, char = ' ') {
  return String(str).padEnd(length, char);
}

function padLeft(str, length, char = ' ') {
  return String(str).padStart(length, char);
}

function padCenter(str, length, char = ' ') {
  const padding = Math.max(0, length - String(str).length); // Asegurarse de que str sea string
  const leftPad = Math.floor(padding / 2);
  const rightPad = padding - leftPad;
  return char.repeat(leftPad) + str + char.repeat(rightPad);
}

function formatCurrencyESCPOS(value) {
  const num = parseNumber(value);
  return `RD$${num.toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function parseNumber(str) {
  if (str === null || str === undefined || String(str).trim() === '') return 0; // String(str).trim() para manejar espacios
  return Number(String(str).replace(/,/g, ''));
}

function wrapText(text, maxWidth) {
  if (String(text).length <= maxWidth) { // Asegurarse de que text sea string
    return [String(text)];
  }

  const words = String(text).split(' '); // Asegurarse de que text sea string
  const lines = [];
  let currentLine = "";

  for (const word of words) {
    if (word.length > maxWidth) {
      // Palabra más larga que el ancho máximo, dividir la palabra
      if (currentLine.length > 0) {
        lines.push(currentLine);
        currentLine = "";
      }
      let tempWord = word;
      while (tempWord.length > maxWidth) {
        lines.push(tempWord.substring(0, maxWidth));
        tempWord = tempWord.substring(maxWidth);
      }
      currentLine = tempWord; // La parte restante de la palabra
      continue;
    }

    if ((currentLine + (currentLine.length > 0 ? " " : "") + word).length <= maxWidth) {
      currentLine += (currentLine.length > 0 ? " " : "") + word;
    } else {
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
      currentLine = word;
    }
  }

  if (currentLine.length > 0) {
    lines.push(currentLine);
  }

  return lines.length > 0 ? lines : [String(text).substring(0, maxWidth)]; // Asegurarse de que text sea string
}

function formatDate(dateString) {
  if (!dateString) return 'No registrada';
  try {
    return new Date(dateString).toLocaleString('es-DO', { // Usar toLocaleString para incluir hora
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true // O false si prefieres formato 24h
    });
  } catch (e) {
    return 'Fecha inválida';
  }
}

// =================================================================
// 📄 FACTURA COMPACTA - 32 CARACTERES (58mm)
// =================================================================
async function generateCompactReceipt32(invoice) {
  const paperWidth = 32;
  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;
  // === ENCABEZADO COMPACTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  // Logo (si está disponible)
  //receipt += CMD.PRINT_NV_LOGO(1, 0); // Asumiendo que el logo 1 está guardado
  receipt += CMD.LF;
  receipt += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Films (Práctica)" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // Disclaimer
  receipt += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += CMD.BOLD_OFF + "Información ficticia" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === DATOS BÁSICOS ===
  receipt += CMD.ALIGN_LEFT;
  receipt += `Fact: ${String(invoice.invoiceNumber || 'N/A').padStart(6, '0')} (Práctica)` + CMD.LF;
  receipt += `Fecha: ${new Date(invoice.invoiceDate || Date.now()).toLocaleDateString('es-DO')} (Práctica)` + CMD.LF;
  receipt += `Cliente: ${(invoice.clientName || 'General').substring(0, 20)} (Práctica)` + CMD.LF;
  receipt += singleLine + CMD.LF;

  // === SERVICIOS SIMPLIFICADOS ===
  receipt += CMD.BOLD_ON + "SERVICIOS:" + CMD.BOLD_OFF + CMD.LF;

  // Combo
  if (invoice.comboName && invoice.comboPrice) {
    const comboPrice = parseNumber(invoice.comboPrice);
    const shortName = String(invoice.comboName).substring(0, 20);
    receipt += `${shortName}` + CMD.LF;
    receipt += `1x ${formatCurrencyESCPOS(comboPrice)}` + CMD.LF;
  }

  // Servicios individuales
  if (invoice.invoiceDetails && Array.isArray(invoice.invoiceDetails)) {
    invoice.invoiceDetails
      .filter(detail => detail && detail.serviceID !== 24) // Asegurar que detail exista
      .forEach(detail => {
        const qty = parseNumber(detail.serviceQty);
        const unitPrice = detail.servicePrice > 0 ? parseNumber(detail.servicePrice) : parseNumber(detail.price);
        const discount = detail.discountApplied ? parseNumber(detail.discountApplied) / 100 : 0;
        const lineTotal = unitPrice * qty * (1 - discount);

        const shortName = String(detail.serviceName || 'Servicio desc.').substring(0, 20);
        receipt += `${shortName}` + CMD.LF;
        receipt += `${qty}x ${formatCurrencyESCPOS(lineTotal)}` + CMD.LF;
      });
  }

  receipt += singleLine + CMD.LF;

  // === TOTALES COMPACTOS ===
  const totalLabelWidth = paperWidth - 12; // Ancho para la etiqueta y el valor
  receipt += padRight("TOTAL:", totalLabelWidth) + padLeft(formatCurrencyESCPOS(parseNumber(invoice.totalAmount)), 12) + CMD.LF;
  receipt += padRight("PAGADO:", totalLabelWidth) + padLeft(formatCurrencyESCPOS(parseNumber(invoice.paidAmount)), 12) + CMD.LF;
  receipt += CMD.BOLD_ON;
  receipt += padRight("PENDIENTE:", totalLabelWidth) + padLeft(formatCurrencyESCPOS(parseNumber(invoice.pendingAmount)), 12) + CMD.LF;
  receipt += CMD.BOLD_OFF;

  // === PIE COMPACTO ===
  receipt += CMD.LF + CMD.ALIGN_CENTER;
  receipt += "¡Gracias por su preferencia! (Práctica)" + CMD.LF;
  receipt += CMD.LF
  receipt += CMD.LF;
  receipt += "Este documento es su comprobante" + CMD.LF;
  receipt += "de pago y garantía de servicio. (Práctica)" + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.CUT_PAPER_FULL;
  return receipt;
}

// =================================================================
// 📄 FACTURA ESTÁNDAR - 48 CARACTERES (80mm)
// =================================================================
async function generateStandardReceipt48(invoice) {
  const paperWidth = 47;
  const qtyChars = 4;
  const totalChars = 12;
  const descChars = paperWidth - qtyChars - totalChars - 2; // 48 - 4 - 12 - 2 = 30

  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);
  const dotLine = ".".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  // === ENCABEZADO PROFESIONAL ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  receipt += CMD.PRINT_NV_LOGO(1, 0);
  receipt += CMD.LF;
  receipt += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Films (Práctica)" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // Disclaimer
  receipt += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += CMD.BOLD_OFF + "Información ficticia - Rama Practica" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === INFORMACIÓN DE FACTURA ===
  receipt += CMD.ALIGN_LEFT;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "FACTURA DE VENTA (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL + CMD.LF;

  const currentDateFormatted = new Date().toLocaleString('es-DO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: true
  });

  receipt += `Factura No.: ${String(invoice.invoiceNumber || 'N/A').padStart(8, '0')} (Práctica)` + CMD.LF;
  receipt += `Fecha: ${formatDate(invoice.invoiceDate || Date.now())} (Práctica)` + CMD.LF;
  receipt += `Emitida: ${currentDateFormatted} (Práctica)` + CMD.LF;
  receipt += `Atendido por: ${invoice.employeeName || 'No registrado'} (Práctica)` + CMD.LF;
  receipt += singleLine + CMD.LF;

  // === CLIENTE ===
  receipt += CMD.BOLD_ON + "DATOS DEL CLIENTE (PRÁCTICA):" + CMD.BOLD_OFF + CMD.LF;
  receipt += `Cliente: ${invoice.clientName || 'Cliente General'} (Práctica)` + CMD.LF;
  if (invoice.phoneNumber) {
    receipt += `Tel: ${invoice.phoneNumber} (Práctica)` + CMD.LF;
  }
  receipt += singleLine + CMD.LF;

  // === SERVICIOS ===
  receipt += CMD.BOLD_ON + "DETALLE DE SERVICIOS:" + CMD.LF;
  receipt += padRight("Descripción", descChars) + " " +
    padCenter("Cant", qtyChars) + " " +
    padLeft("Total", totalChars) + CMD.LF;
  receipt += CMD.BOLD_OFF;
  receipt += dotLine + CMD.LF;

  let subtotalServices = 0; // Renombrado para evitar confusión con variable global

  // Combo
  if (invoice.comboName && invoice.comboPrice) {
    const comboPrice = parseNumber(invoice.comboPrice);
    const nameLines = wrapText(invoice.comboName, descChars);

    nameLines.forEach((line, index) => {
      if (index === 0) {
        receipt += CMD.BOLD_ON + padRight(line, descChars) + " " +
          padCenter("1", qtyChars) + " " +
          padLeft(formatCurrencyESCPOS(comboPrice), totalChars) + CMD.BOLD_OFF + CMD.LF;
        receipt += CMD.TEXT_SIZE_CONDENSED;
        receipt += CMD.TEXT_SCALE_SMALLER;
        receipt += padLeft(`(${formatCurrencyESCPOS(comboPrice)} c/u)`, (totalChars + qtyChars)) +
          " ".repeat(totalChars) + CMD.LF; // Ajustado el padding
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
        receipt += CMD.TEXT_SCALE_NORMAL_FONT;
      } else {
        receipt += padRight(line, descChars) + " " +
          " ".repeat(qtyChars) + " " +
          " ".repeat(totalChars) + CMD.LF;
      }
    });

    if (invoice.invoiceDetails && Array.isArray(invoice.invoiceDetails)) {
      invoice.invoiceDetails
        .filter(detail => detail && detail.serviceID === 24)
        .forEach(detail => {
          receipt += CMD.TEXT_SCALE_SMALLER;
          receipt += padRight(`(${formatCurrencyESCPOS(detail.amount)} pagados)`, descChars + qtyChars + 1) + CMD.LF;
          if (detail.amount && detail.amount < comboPrice) {
            receipt += padRight(`(${formatCurrencyESCPOS(comboPrice - detail.amount)} pendientes)`, descChars + qtyChars + 1) + CMD.LF;
          }
          receipt += CMD.TEXT_SCALE_NORMAL_FONT;
        });
    }
    receipt += CMD.LF; // Espacio entre servicios
    subtotalServices += comboPrice;
  }

  // Servicios individuales
  if (invoice.invoiceDetails && Array.isArray(invoice.invoiceDetails)) {
    invoice.invoiceDetails
      .filter(detail => detail && detail.serviceID !== 24)
      .filter(detail => detail.originalSelectedServiceID === null) // Asegurar que no se incluyan servicios inactivos
      .forEach(detail => {
        const qty = parseNumber(detail.serviceQty);
        const unitPrice = detail.servicePrice !== null && parseNumber(detail.servicePrice) > 0 ? parseNumber(detail.servicePrice) : parseNumber(detail.price);
        const discount = detail.discountApplied ? parseNumber(detail.discountApplied) / 100 : 0;
        const lineTotal = unitPrice * qty * (1 - discount);
        let linePaid = 0;
        let linePending = 0;
        if (detail.amount && detail.amount !== null && detail.amount > 0) {
          linePaid = detail.amount;
          linePending = (unitPrice * qty * (1 - discount)) - detail.amount;
        } else {
          linePending = lineTotal;
        }

        const nameLines = wrapText(detail.serviceName || 'Servicio desc.', descChars);

        nameLines.forEach((line, index) => {
          if (index === 0) {
            receipt += CMD.BOLD_ON + padRight(line, descChars) + " " +
              padCenter(String(qty), qtyChars) + " " +
              padLeft(formatCurrencyESCPOS(lineTotal), totalChars) + CMD.BOLD_OFF + CMD.LF;

            // Línea con precio unitario y descuento (si aplica) en la misma línea
            receipt += CMD.TEXT_SCALE_SMALLER;
            receipt += CMD.TEXT_SIZE_CONDENSED;
            let priceDiscountLine = "";
            priceDiscountLine += padRight(`(${formatCurrencyESCPOS(unitPrice)} c/u)`, descChars + qtyChars + 1) + CMD.LF;

            if (discount > 0) {
              receipt += priceDiscountLine += padRight(`(${formatCurrencyESCPOS(unitPrice * qty * discount)} de Dto.)`, descChars + qtyChars + 1) + CMD.LF
            }
            receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
            receipt += CMD.TEXT_SCALE_NORMAL_FONT;
          } else {
            receipt += padRight(line, descChars) + " " +
              " ".repeat(qtyChars) + " " +
              " ".repeat(totalChars) + CMD.LF;
          }
        });

        // Agregar información de pagos por servicio
        receipt += CMD.TEXT_SCALE_SMALLER;
        receipt += CMD.TEXT_SIZE_CONDENSED;
        if (linePaid > 0) {
          receipt += padRight(`(${formatCurrencyESCPOS(linePaid)} pagados)`, (descChars + qtyChars + 1)) + CMD.LF;
        }
        if (linePending > 0) {
          receipt += padRight(`(${formatCurrencyESCPOS(linePending)} pendientes)`, descChars + qtyChars + 1) + CMD.LF;
        }
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
        receipt += CMD.TEXT_SCALE_NORMAL_FONT;
        receipt += CMD.LF; // Espacio entre servicios

        subtotalServices += lineTotal;
      });
  }

  receipt += dotLine + CMD.LF;

  // === TOTALES ===
  const totalsLabelWidth = paperWidth - totalChars - 1; // Ancho para la etiqueta y el valor
  receipt += padRight("TOTAL:", totalsLabelWidth) +
    padLeft(formatCurrencyESCPOS(parseNumber(invoice.totalAmount)), totalChars) + CMD.LF;
  receipt += padRight("PAGADO:", totalsLabelWidth) +
    padLeft(formatCurrencyESCPOS(parseNumber(invoice.paidAmount)), totalChars) + CMD.LF;

  if (parseNumber(invoice.pendingAmount) > 0) {
    receipt += CMD.BOLD_ON;
    receipt += padRight("PENDIENTE:", totalsLabelWidth) +
      padLeft(formatCurrencyESCPOS(parseNumber(invoice.pendingAmount)), totalChars) + CMD.LF;
    receipt += CMD.BOLD_OFF;
  }

  receipt += doubleLine + CMD.LF;

  // === PIE DE PÁGINA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.BOLD_ON + "¡GRACIAS POR SU PREFERENCIA! (PRÁCTICA)" + CMD.BOLD_OFF + CMD.LF;
  receipt += CMD.LF + "Este documento es falso" + CMD.LF;
  receipt += CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.LF;
  receipt += CMD.LF;
  receipt += CMD.CUT_PAPER_FULL;

  return receipt;
}

// =================================================================
// 📄 FACTURA PREMIUM - 80 CARACTERES (¿112mm? -> 80 caracteres se asocia más a 80mm de papel)
// Si el papel es de 112mm, el ancho en caracteres sería mayor, ej. ~100-112.
// Ajustaré para 80 caracteres, que es común para impresoras de 80mm.
// =================================================================
async function generatePremiumReceipt80(invoice) {
  const paperWidth = 80; // Este es el ancho en caracteres, no en mm.
  const qtyChars = 6;
  const unitPriceChars = 12;
  const totalChars = 14;
  const descChars = paperWidth - qtyChars - unitPriceChars - totalChars - 3; // 80 - 6 - 12 - 14 - 3 = 45

  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);
  const dotLine = ".".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  // === ENCABEZADO CORPORATIVO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  receipt += CMD.PRINT_NV_LOGO(1, 0);
  receipt += CMD.LF;
  receipt += "D'PRINCESS SANTIAGO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Films (Práctica)" + CMD.LF;
  receipt += "Teléfono: (809) 000-0000 | WhatsApp: (809) 000-0000 (Práctica)" + CMD.LF; // Reemplazar
  receipt += "Email: info@dprincess.com (Práctica)" + CMD.LF; // Reemplazar
  receipt += "Dirección: Edificio Comercial La Fuente (Práctica)" + CMD.LF;
  receipt += "Av. Yapur Dumit esq., Santiago, República Dominicana (Práctica)" + CMD.LF; // Corregido: coma y país
  receipt += doubleLine + CMD.LF;

  // Disclaimer
  receipt += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  receipt += "*** VERSIÓN DE PRÁCTICA - INFORMACIÓN FICTICIA ***" + CMD.LF;
  receipt += CMD.BOLD_OFF + "No representa datos reales. Rama Practica." + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === INFORMACIÓN DETALLADA DE FACTURA ===
  receipt += CMD.ALIGN_LEFT;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "DOCUMENTO DE FACTURACIÓN (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL + CMD.LF;

  const currentDateFormattedPremium = new Date().toLocaleString('es-DO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: true
  });

  const colWidth = Math.floor(paperWidth / 2) - 1; // Ancho para cada columna de información

  receipt += padRight(`Factura No.: ${String(invoice.invoiceNumber || 'N/A').padStart(8, '0')} (Práctica)`, colWidth) + " " +
    padLeft(`Fecha: ${formatDate(invoice.invoiceDate || Date.now())} (Práctica)`, colWidth) + CMD.LF;
  receipt += padRight(`Emitida: ${currentDateFormattedPremium} (Práctica)`, colWidth) + " " +
    padLeft(`Atendido por: ${invoice.employeeName || 'No registrado'} (Práctica)`, colWidth) + CMD.LF;
  receipt += singleLine + CMD.LF;

  // === INFORMACIÓN COMPLETA DEL CLIENTE ===
  receipt += CMD.BOLD_ON + "INFORMACIÓN DEL CLIENTE (PRÁCTICA):" + CMD.BOLD_OFF + CMD.LF;
  receipt += `Nombre: ${invoice.clientName || 'Cliente General'} (Práctica)` + CMD.LF;
  if (invoice.phoneNumber) {
    receipt += `Teléfono: ${invoice.phoneNumber} (Práctica)` + CMD.LF;
  }
  if (invoice.clientEmail) {
    receipt += `Email: ${invoice.clientEmail} (Práctica)` + CMD.LF;
  }
  if (invoice.address) {
    receipt += `Dirección: ${invoice.address} (Práctica)` + CMD.LF;
  }
  receipt += singleLine + CMD.LF;

  // === INFORMACIÓN DEL EVENTO (si existe) ===
  if (invoice.eventTitle || invoice.eventLocation) {
    receipt += CMD.BOLD_ON + "INFORMACIÓN DEL EVENTO:" + CMD.BOLD_OFF + CMD.LF;
    if (invoice.eventTitle) {
      receipt += `Evento: ${invoice.eventTitle}` + CMD.LF;
    }
    if (invoice.eventLocation) {
      receipt += `Lugar: ${invoice.eventLocation}` + CMD.LF;
    }
    if (invoice.eventDateStart) {
      receipt += `Fecha inicio: ${formatDate(invoice.eventDateStart)}` + CMD.LF;
    }
    receipt += singleLine + CMD.LF;
  }

  // === DETALLE COMPLETO DE SERVICIOS ===
  receipt += CMD.BOLD_ON + "DETALLE COMPLETO DE SERVICIOS:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Descripción del Servicio", descChars) + " " +
    padCenter("Cant.", qtyChars) + " " +
    padCenter("Precio Unit.", unitPriceChars) + " " +
    padLeft("Total", totalChars) + CMD.LF;
  receipt += dotLine + CMD.LF;

  let subtotalPremium = 0; // Renombrado
  let totalDiscountPremium = 0; // Renombrado

  // Combo detallado
  if (invoice.comboName && invoice.comboPrice) {
    const comboPrice = parseNumber(invoice.comboPrice);
    const nameLines = wrapText(invoice.comboName, descChars);

    nameLines.forEach((line, index) => {
      if (index === 0) {
        receipt += padRight(line + " [PAQUETE]", descChars) + " " +
          padCenter("1", qtyChars) + " " +
          padLeft(formatCurrencyESCPOS(comboPrice), unitPriceChars) + " " +
          padLeft(formatCurrencyESCPOS(comboPrice), totalChars) + CMD.LF;
      } else {
        receipt += padRight(line, descChars) + " " +
          " ".repeat(qtyChars) + " " +
          " ".repeat(unitPriceChars) + " " +
          " ".repeat(totalChars) + CMD.LF;
      }
    });
    subtotalPremium += comboPrice;
  }

  // Servicios individuales detallados
  if (invoice.invoiceDetails && Array.isArray(invoice.invoiceDetails)) {
    invoice.invoiceDetails
      .filter(detail => detail && detail.serviceID !== 24)
      .forEach(detail => {
        const qty = parseNumber(detail.serviceQty);
        const unitPrice = detail.servicePrice > 0 ? parseNumber(detail.servicePrice) : parseNumber(detail.price);
        const discount = detail.discountApplied ? parseNumber(detail.discountApplied) / 100 : 0;
        const lineTotalWithoutDiscount = unitPrice * qty;
        const discountAmount = lineTotalWithoutDiscount * discount;
        const lineTotalWithDiscount = lineTotalWithoutDiscount - discountAmount;

        if (discount > 0) {
          totalDiscountPremium += discountAmount;
        }

        const nameLines = wrapText(detail.serviceName || 'Servicio desc.', descChars);

        nameLines.forEach((line, index) => {
          if (index === 0) {
            receipt += padRight(line + " [SERVICIO]", descChars) + " " +
              padCenter(String(qty), qtyChars) + " " +
              padLeft(formatCurrencyESCPOS(unitPrice), unitPriceChars) + " " +
              padLeft(formatCurrencyESCPOS(lineTotalWithDiscount), totalChars) + CMD.LF;

            if (discount > 0) {
              receipt += padRight(`  Descuento aplicado: ${(discount * 100).toFixed(0)}%`, descChars + qtyChars + unitPriceChars + 2) + // Ajuste de padding
                padLeft(`-${formatCurrencyESCPOS(discountAmount)}`, totalChars) + CMD.LF;
            }
          } else {
            receipt += padRight(line, descChars) + " " +
              " ".repeat(qtyChars) + " " +
              " ".repeat(unitPriceChars) + " " +
              " ".repeat(totalChars) + CMD.LF;
          }
        });
        subtotalPremium += lineTotalWithDiscount; // Sumar el total con descuento
      });
  }

  receipt += dotLine + CMD.LF;

  // === RESUMEN FINANCIERO DETALLADO ===
  const totalsLabelWidthPremium = paperWidth - totalChars - 1; // Ancho para la etiqueta
  // El subtotal debe ser la suma de los precios antes de descuentos de línea si ya se mostraron
  // Si el invoice.totalAmount ya incluye los descuentos, entonces usamos ese como base
  // Para simplificar, asumimos que invoice.totalAmount es el total final después de todos los descuentos.
  // Si queremos mostrar un subtotal bruto, necesitaríamos sumar precios originales.
  // Por ahora, usaremos subtotalPremium que ya considera descuentos de línea.

  const grossSubtotal = parseNumber(invoice.totalAmount) + totalDiscountPremium;

  receipt += padRight("SUBTOTAL BRUTO:", totalsLabelWidthPremium) +
    padLeft(formatCurrencyESCPOS(grossSubtotal), totalChars) + CMD.LF;


  if (totalDiscountPremium > 0) {
    receipt += padRight("DESCUENTOS APLICADOS:", totalsLabelWidthPremium) +
      padLeft(`-${formatCurrencyESCPOS(totalDiscountPremium)}`, totalChars) + CMD.LF;
  }

  receipt += CMD.BOLD_ON;
  receipt += padRight("TOTAL GENERAL:", totalsLabelWidthPremium) +
    padLeft(formatCurrencyESCPOS(parseNumber(invoice.totalAmount)), totalChars) + CMD.LF;
  receipt += CMD.BOLD_OFF;

  receipt += singleLine + CMD.LF;

  // Estado de pagos detallado
  receipt += CMD.BOLD_ON + "ESTADO DE PAGOS:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Monto total pagado:", totalsLabelWidthPremium) +
    padLeft(formatCurrencyESCPOS(parseNumber(invoice.paidAmount)), totalChars) + CMD.LF;

  if (parseNumber(invoice.pendingAmount) > 0) {
    receipt += CMD.BOLD_ON;
    receipt += padRight("MONTO PENDIENTE:", totalsLabelWidthPremium) +
      padLeft(formatCurrencyESCPOS(parseNumber(invoice.pendingAmount)), totalChars) + CMD.LF;
    receipt += CMD.BOLD_OFF;
  } else {
    receipt += CMD.BOLD_ON;
    receipt += padCenter("*** FACTURA PAGADA COMPLETAMENTE ***", paperWidth) + CMD.LF;
    receipt += CMD.BOLD_OFF;
  }

  receipt += doubleLine + CMD.LF;

  // === CÓDIGO DE BARRAS ===
  if (invoice.invoiceNumber) {
    const barcodeData = String(invoice.invoiceNumber).trim();
    if (barcodeData.length > 0 && barcodeData.length < 256) { // Límite para Code128
      receipt += CMD.ALIGN_CENTER;
      receipt += CMD.BARCODE_HEIGHT_DEFAULT;
      receipt += CMD.BARCODE_WIDTH_MODULE_DEFAULT;
      receipt += CMD.HRI_POSITION_BELOW;

      // Usar Code128 (Set B para numérico y alfanumérico simple)
      let code128Command = GS + 'k' + '\x49'; // \x49 es para CODE128
      code128Command += String.fromCharCode(barcodeData.length); // n = número de bytes de datos
      code128Command += barcodeData; // d1 ... dk

      receipt += code128Command + CMD.LF + CMD.LF;
    }
  }

  // === PIE DE PÁGINA CORPORATIVO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += doubleLine + CMD.LF;
  receipt += CMD.BOLD_ON + "¡GRACIAS POR CONFIAR EN D'PRINCESS FOTO FILM! (PRÁCTICA)" + CMD.BOLD_OFF + CMD.LF;
  receipt += CMD.LF;
  receipt += "Este documento constituye su comprobante oficial de pago" + CMD.LF;
  receipt += "y garantía de los servicios contratados. (Práctica)" + CMD.LF;
  receipt += CMD.LF;
  receipt += "ATENCIÓN AL CLIENTE Y GARANTÍAS (PRÁCTICA):" + CMD.LF;
  receipt += "WhatsApp: (809) 000-0000 (Práctica)" + CMD.LF; // Reemplazar
  receipt += "Email: soporte@dprincess.com (Práctica)" + CMD.LF; // Reemplazar
  receipt += "Horario: Lunes a Sábado de 8:00 AM a 8:00 PM (Práctica)" + CMD.LF;
  receipt += CMD.LF;
  receipt += `Documento válido hasta: ${new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toLocaleDateString('es-DO')} (Práctica)` + CMD.LF; // Corregido: valido -> válido
  receipt += CMD.LF;
  receipt += "Conserve este documento para futuras referencias. (Práctica)" + CMD.LF; // Corregido: punto final

  receipt += CMD.LF + CMD.LF + CMD.LF + CMD.CUT_PAPER_FULL;

  return receipt;
}

// =================================================================
// 💵 RECIBO DE PAGO - 48 CARACTERES (80mm)
// =================================================================
async function generatePaymentReceipt48(paymentData, associatedInvoiceData = null) {
  console.log("Generando recibo de pago con datos:", paymentData);
  console.log("Datos de la factura asociada:", associatedInvoiceData);  
  
  const paperWidth = 47; // Ajustado para evitar desbordamiento en algunas impresoras
  const labelChars = 18;
  const valueChars = paperWidth - labelChars - 1;
  let registeredBy = "No registrado"; // Valor por defecto si no se encuentra el empleado

  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  // === ENCABEZADO DEL NEGOCIO ===
  receipt += CMD.ALIGN_CENTER;
  // Si tienes un logo para recibos, puedes usarlo aquí.
  receipt += CMD.PRINT_NV_LOGO(1, 0); 
  receipt += CMD.LF;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Film (Práctica)" + CMD.LF;
  receipt += "Tel.: (809) 708-5336 (Práctica)" + CMD.LF;
  receipt += "Edificio Comercial La Fuente (Práctica)" + CMD.LF;
  receipt += "Av. Yapur Dumit esq., Santiago (Práctica)" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // Disclaimer
  receipt += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += CMD.BOLD_OFF + "Información ficticia - Rama Practica" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === TÍTULO DEL DOCUMENTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "RECIBO DE PAGO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += CMD.LF;

  // === INFORMACIÓN DEL RECIBO ===
  receipt += CMD.ALIGN_LEFT;
  receipt += padRight("No. Recibo:", labelChars) + " " + padLeft(String(paymentData.receiptDocumentNumber || 'N/A'), valueChars) + " (Práctica)" + CMD.LF;
  receipt += padRight("Fecha Transacción:", labelChars) + " " + padLeft(formatDate(paymentData.transactionDate || Date.now()), valueChars) + " (Práctica)" + CMD.LF;
  receipt += padRight("Fecha de Emisión:", labelChars) + " " + padLeft(formatDate(Date.now()), valueChars) + " (Práctica)" + CMD.LF;

  if (associatedInvoiceData && associatedInvoiceData.invoiceNumber) {
    receipt += padRight("Factura No.:", labelChars) + " " + padLeft(String(associatedInvoiceData.invoiceNumber), valueChars) + " (Práctica)" + CMD.LF;
    receipt += padRight("Fecha Factura:", labelChars) + " " + padLeft(formatDate(associatedInvoiceData.invoiceDate || Date.now()), valueChars) + " (Práctica)" + CMD.LF;
  } else if (paymentData.invoiceID) {
    receipt += padRight("Factura ID:", labelChars) + " " + padLeft(String(paymentData.invoiceID), valueChars) + " (Práctica)" + CMD.LF;
  }

  if (associatedInvoiceData && associatedInvoiceData.clientName) {
    receipt += padRight("Cliente:", labelChars) + " " + padLeft(String(associatedInvoiceData.clientName).substring(0, valueChars), valueChars) + " (Práctica)" + CMD.LF;
  }

  // Asumiendo que tienes una forma de obtener el nombre del empleado a partir de registeredByUserID
  if (associatedInvoiceData && associatedInvoiceData.employeeName && paymentData.registeredByUserID === associatedInvoiceData.employeeID) {
    registeredBy = String(associatedInvoiceData.employeeName).substring(0, valueChars);
  } else if (paymentData.employeeName) { // Si el dato viniera en paymentData
    registeredBy = String(paymentData.employeeName).substring(0, valueChars);
  }
  receipt += padRight("Registrado por:", labelChars) + " " + padLeft(registeredBy, valueChars) + " (Práctica)" + CMD.LF;
  receipt += singleLine + CMD.LF;

  // === DETALLES DEL PAGO ===
  receipt += CMD.BOLD_ON + "CONCEPTOS PAGADOS:" + CMD.BOLD_OFF + CMD.LF;

  if (paymentData.details && Array.isArray(paymentData.details)) {
    paymentData.details.forEach(detail => {
      const conceptLines = wrapText(detail.concept || "Pago general", paperWidth);
      conceptLines.forEach((line, index) => {
        if (index === 0) {
          receipt += padRight(line, paperWidth - 12) + CMD.LF;
          receipt += padRight("Monto:", labelChars + 5) + padLeft(formatCurrencyESCPOS(detail.amountPaid), valueChars - 4) + CMD.LF; 
        } else {
          receipt += line + CMD.LF;
        }
      });
    });
  } else {
    // Si no hay detalles específicos, mostrar el concepto general del recibo si existe
    const conceptLines = wrapText(paymentData.notes || "Abono a factura", paperWidth);
    conceptLines.forEach((line) => {
      receipt += line + CMD.LF;
    });
  }
  receipt += singleLine + CMD.LF;

  // === DETALLE DEL PAGO ACTUAL Y RESUMEN DE CUENTA ===
  receipt += CMD.BOLD_ON + "DETALLE DEL PAGO ACTUAL:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Monto Recibido:", labelChars + 5) + padLeft(formatCurrencyESCPOS(paymentData.totalAmountReceived), valueChars - 4) + CMD.LF;
  receipt += padRight("Método de Pago:", labelChars + 5) + padLeft(String(paymentData.paymentMethod || 'N/D').toUpperCase(), valueChars - 4) + CMD.LF;
  if (paymentData.referenceNumber) {
    receipt += padRight("Referencia:", labelChars + 5) + padLeft(String(paymentData.referenceNumber), valueChars - 4) + CMD.LF;
  }
  receipt += singleLine + CMD.LF;

  if (associatedInvoiceData) {
    receipt += CMD.BOLD_ON + `RESUMEN DE CUENTA (Factura ${associatedInvoiceData.invoiceNumber || paymentData.invoiceID || 'N/A'}):` + CMD.BOLD_OFF + CMD.LF;

    const originalTotal = parseNumber(associatedInvoiceData.totalAmount);
    const currentPayment = parseNumber(paymentData.totalAmountReceived);
    // Para "Pagos Anteriores", necesitamos el total pagado en la factura *antes* de este pago actual.
    // Si associatedInvoiceData.paidAmount ya incluye este pago, debemos restarlo.
    // Si no lo incluye, podemos usarlo directamente.
    // Asumiremos que associatedInvoiceData.paidAmount es el total pagado *después* de este pago actual.
    const totalPaidOnInvoiceAfterThisPayment = parseNumber(associatedInvoiceData.paidAmount);
    const previousPayments = totalPaidOnInvoiceAfterThisPayment - currentPayment;
    const totalPendingAfterThisPayment = parseNumber(associatedInvoiceData.pendingAmount);


    receipt += padRight("Total Servicios Original:", labelChars + 2) + padLeft(formatCurrencyESCPOS(originalTotal), valueChars - 6) + CMD.LF;
    receipt += padRight("Monto de Este Pago:", labelChars + 4) + padLeft(formatCurrencyESCPOS(currentPayment), valueChars - 4) + CMD.LF;
    receipt += singleLine + CMD.LF;
    receipt += CMD.BOLD_ON;
    receipt += padRight("TOTAL PAGADO A LA FECHA:", labelChars + 2) + padLeft(formatCurrencyESCPOS(paymentData.isFromPayment ? totalPaidOnInvoiceAfterThisPayment + currentPayment : totalPaidOnInvoiceAfterThisPayment), valueChars - 6) + CMD.LF;
    if (associatedInvoiceData.pendingAmount > 0) {
      receipt += padRight("SALDO PENDIENTE:", labelChars + 2) + padLeft(formatCurrencyESCPOS(paymentData.isFromPayment ? totalPendingAfterThisPayment - currentPayment : totalPendingAfterThisPayment), valueChars - 4) + CMD.LF;
    }
    else {
      receipt += padCenter("*** FACTURA PAGADA COMPLETAMENTE ***", paperWidth) + CMD.LF;
    }
    receipt += CMD.BOLD_OFF;
  } else {
    // Si no hay datos de factura asociada, solo mostrar el total de este pago
    receipt += CMD.ALIGN_RIGHT;
    receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH;
    receipt += CMD.BOLD_ON;
    receipt += padRight("TOTAL RECIBIDO:", paperWidth - 15) + padLeft(formatCurrencyESCPOS(paymentData.totalAmountReceived), 15) + CMD.LF;
    receipt += CMD.BOLD_OFF;
    receipt += CMD.TEXT_SIZE_NORMAL;
    receipt += CMD.ALIGN_LEFT;
  }
  receipt += doubleLine + CMD.LF;

  // === PIE DE PÁGINA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.BOLD_ON + "¡GRACIAS POR SU PAGO! (PRÁCTICA)" + CMD.BOLD_OFF + CMD.LF;
  if (paymentData.notes) {
    receipt += CMD.LF;
    const noteLines = wrapText("Nota: " + paymentData.notes, paperWidth);
    noteLines.forEach(line => {
      receipt += line + CMD.LF;
    });
  }
  receipt += CMD.LF;
  receipt += "Conserve este recibo como comprobante. (Práctica)" + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.LF + CMD.LF; // Más espacio antes del corte
  receipt += CMD.CUT_PAPER_FULL;

  return receipt;
}

// =================================================================
// 🎯 FUNCIÓN PRINCIPAL INTELIGENTE
// =================================================================
async function generateThermalReceiptESCPOS(invoice, paperWidthCharsProvided) {
  if (!invoice) return "";

  // Validar y usar un valor por defecto si paperWidthCharsProvided no es un número válido
  let paperWidthChars = parseInt(paperWidthCharsProvided, 10);
  if (isNaN(paperWidthChars) || paperWidthChars <= 0) {
    console.warn(`Ancho de papel proporcionado ('${paperWidthCharsProvided}') no es válido. Usando 48 por defecto.`);
    paperWidthChars = 48; // Un valor por defecto razonable (para 80mm)
  }

  // La lógica de ajuste original parecía restar 10, la comentaré por si era intencional
  // pero generalmente se usa el ancho directo para las funciones.
  // console.log("Original paperWidthChars:", paperWidthChars);
  paperWidthChars = paperWidthChars - 10; // ¿Por qué se restaba 10?
  // console.log("Adjusted paperWidthChars:", paperWidthChars);

  // Determinar automáticamente el formato basado en el ancho
  // Los cases deben coincidir con los anchos definidos en las funciones de generación
  if (paperWidthChars <= 32) { // Límite inferior para compacto
    return await generateCompactReceipt32(invoice);
  } else if (paperWidthChars <= 48) { // Límite para estándar
    return await generateStandardReceipt48(invoice);
  } else { // Para cualquier ancho mayor, usar premium (o el más grande disponible)
    return await generatePremiumReceipt80(invoice);
  }
}

// Exportar funciones individuales para uso específico
export {
  generateCompactReceipt32,
  generateStandardReceipt48,
  generatePremiumReceipt80,
  generatePaymentReceipt48
};

export default generateThermalReceiptESCPOS;